import '../../../../vendor/angular-validation-match/dist/angular-input-match';

export const validationMatchComponentModule = 'validation.match';
